// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_Kmo","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_VZh StatelessWorkCardsUpsellModal-styles-cls1_Kmo"};